const investFlowTrackActionData = {
  first: {
    category: 'clearinvest',
    action: 'personal_details',
  },
  second: {
    category: 'clearinvest',
    action: 'bank_details',
  },
  third: {
    category: 'clearinvest',
    action: 'pincode_city',
  },
  payment: {
    category: 'clearinvest',
    action: 'proceed_to_pay',
  },
};
export { investFlowTrackActionData };



// WEBPACK FOOTER //
// ./constants/trackActionConstants.ts